<template>
    <div class="page">
        <v-container class="py-3 py-lg-6 px-3">
            <v-card v-if="links" :class="{'py-2 px-3 bordered': pcOnly}" flat>
                <v-card-title :class="{'justify-center mb-2 px-2': phoneOnly}">روابطنا الرسمية</v-card-title>
                <v-card-text :class="{'px-0': phoneOnly}">
                    <div class="d-flex flex-column" style="max-width: 400px;">
                        <v-btn v-for="(item, i) in links" block :key="i" large class="mb-4 px-3" depressed :color="item.color" dark :href="item.url" :target="capRunning ? '_system' : '_blank'">
                            <div class="me-1">
                                <svg v-if="item.icon === 'mdi-telegram'" fill="currentColor" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 50 50" :width="25 + 'px'" :height="25 + 'px'"><path d="M46.137,6.552c-0.75-0.636-1.928-0.727-3.146-0.238l-0.002,0C41.708,6.828,6.728,21.832,5.304,22.445	c-0.259,0.09-2.521,0.934-2.288,2.814c0.208,1.695,2.026,2.397,2.248,2.478l8.893,3.045c0.59,1.964,2.765,9.21,3.246,10.758	c0.3,0.965,0.789,2.233,1.646,2.494c0.752,0.29,1.5,0.025,1.984-0.355l5.437-5.043l8.777,6.845l0.209,0.125	c0.596,0.264,1.167,0.396,1.712,0.396c0.421,0,0.825-0.079,1.211-0.237c1.315-0.54,1.841-1.793,1.896-1.935l6.556-34.077	C47.231,7.933,46.675,7.007,46.137,6.552z M22,32l-3,8l-3-10l23-17L22,32z"/></svg>
                                <v-icon v-else size="25">{{item.icon || 'mdi-link'}}</v-icon>
                            </div>
                            <v-list-item-content style="font-size: 15px;">
                                {{item.label}}
                            </v-list-item-content>
                        </v-btn>
                    </div>

                    <div class="text-center mt-8">
                        <logo :link="false" />
                    </div>
                </v-card-text>
            </v-card>
        </v-container>

        <slot v-if="!isAuthed" name="footer" />
    </div>
</template>
<script>

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    components: {
        
    },
    data(){
        return {
            loading: false,
            links: null,
        }
    },
    computed: {
        ...GlobalComputed,
    },
    watch: {
        loading(loading){
            this.setLinearLoading(loading);
        },
    },
    methods: {
        ...GlobalMethods,
        getLinks(){
            if (!this.loading){
                this.loading = true;
                const url = '/links';
                this.$store.dispatch('fastGetAction', {url}).then(response=>{
                    this.loading = false;
                    this.links = response.data;

                }).catch(()=>{
                    this.showMsg('حدثت مشكلة أثناء تحميل البيانات');
                    this.loading = false;
                });
            }
        },
    },
    mounted(){
        if (!this.links){
            this.getLinks();
        }
    }
}
</script>